function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    height: 23,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ffffff",
      stroke: "#bebebe",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    rx: 12,
    ry: 11.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.5,
    rx: 11.5,
    ry: 11,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x2: 15.889088,
    x1: 8.1109123,
    y1: 15.389088,
    y2: 7.6109128,
    style: {
      fill: "none",
      stroke: "#880303",
      strokeWidth: 1,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x2: 15.889088,
    x1: 8.1109123,
    y1: 7.6109128,
    y2: 15.389088,
    style: {
      fill: "none",
      stroke: "#880303",
      strokeWidth: 1,
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCross);
export default __webpack_public_path__ + "static/media/remove-cross.2410c80d432fadee3905a470009f2088.svg";
export { ForwardRef as ReactComponent };